<app-navbar-style-two></app-navbar-style-two>

<div class="privacy-policy-section">
  <div class="container">

    <div class="policy-header">
      <span class="policy-badge">🔒 Privacy Policy</span>

      <h1>Sangeetha Toys</h1>

      <p>
        At Sangeetha Toys, we value your trust and are committed to protecting
        your personal information. This Privacy Policy explains how we collect,
        use, store, and safeguard your information when you visit our website
        or make a purchase.
      </p>
    </div>

    <div class="policy-content">

      <div class="policy-item">
        <h4>1. Information We Collect</h4>
        <ul>
          <li>Name, email address, phone number, shipping address, and billing information.</li>
          <li>Order history, product preferences, and customer support interactions.</li>
          <li>Website usage data collected through cookies and analytics tools.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>2. How We Use Your Information</h4>
        <ul>
          <li>To process orders and deliver products efficiently.</li>
          <li>To provide customer support and respond to inquiries.</li>
          <li>To improve our website, products, and shopping experience.</li>
          <li>To send order updates, promotional offers, and important notifications.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>3. Cookies & Tracking Technologies</h4>
        <ul>
          <li>Cookies help us remember your preferences and improve website functionality.</li>
          <li>Analytics tools help us understand visitor behavior and optimize performance.</li>
          <li>You may disable cookies through your browser settings if preferred.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>4. Data Security</h4>
        <ul>
          <li>We implement industry-standard security measures to protect your information.</li>
          <li>Personal information is stored securely and accessed only by authorized personnel.</li>
          <li>We do not sell, rent, or trade your personal information to third parties.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>5. Sharing of Information</h4>
        <ul>
          <li>Information may be shared with trusted delivery and payment partners solely for order fulfillment.</li>
          <li>We may disclose information if required by law or regulatory authorities.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>6. Your Rights</h4>
        <ul>
          <li>You may request access to your personal information.</li>
          <li>You may request corrections or updates to inaccurate data.</li>
          <li>You may request deletion of your personal information, subject to legal requirements.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>7. Contact Us</h4>
        <ul>
          <li>For privacy-related questions or requests, please contact our support team.</li>
          <li>We will respond to all legitimate requests within a reasonable timeframe.</li>
        </ul>
      </div>

    </div>

  </div>
</div>